<fieldset>
  <button [disabled]="disabled" type="button" id="{{aid}}" (click)="toggle($event)">
    @if (icon) {
      <i class="icon {{icon}}"></i>
    }
    <ng-content></ng-content>
    @if (options && showChevron && !showOptions) {
      <i class="toggle fa-solid fa-chevron-down"></i>
    }
    @if (options && showChevron && showOptions) {
      <i class="toggle fa-solid fa-chevron-up"></i>
    }
  </button>
  @if (infoText) {
    <rask-info><span [innerHTML]="infoText"></span></rask-info>
  }
  <div>
    @if (showOptions) {
      <div class="drop-down-menu p-0" [ngClass]="alignment">
        @for (option of options; track option) {
          <div>
            <button class="optionButton" (mousedown)="optionClicked(option)">{{ option.value }}</button>
          </div>
        }
      </div>
    }
  </div>
</fieldset>